export function decorateRegionWithUSPrefix(region?: string): string {
  return region?.includes('US') ? region : `US-${region}`;
}

export function clearRegionUSPrefix(region?: string): string {
  return region?.replace('US-', '') ?? '';
}
